// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

export const LeftContainer = styled.div`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    max-width: 600px;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 522px;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    & h2 {
      max-width: 460px;
    }
    & div div span {
      white-space: nowrap;
    }
  }
`;

export const Wrapper = styled.div`
  /* background-color: ${({ theme }) => theme.colors.base.dark}; */
  min-height: 720px;
`;
